import Swiper from "swiper";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

export default function swiperPropertyListing() {
    const swiper = new Swiper(".property-listing__swiper", {
        modules: [Navigation],

        // Params
        loop: false,
        grabCursor: true,
        speed: 800,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,

        // Navigation
        navigation: {
            prevEl: ".property-listing__swiper ~ .swiper-button-prev",
            nextEl: ".property-listing__swiper ~ .swiper-button-next",
        },

        breakpoints: {
            992: {
                slidesPerView: 2,
            },
            1480: {
                slidesPerView: 3,
            },
        },
    });
}
